import React, { useState, useContext, useRef } from "react";
import moment from "moment/moment";
import numberbeautify from "../../../utils/numberbeautify";
import money_rounding from "../../../utils/money_rounding";

const Loan_in_detail_modal = (props) => {
    return (
            props.show ? (
            <>
                {/* <div style={{display:'none'}}>
                    <Loanbackprint ref={printRef} dollar_price={dollar_price} loan_in_id={loan_in_id} loan_in_date={loan_in_date} amount={amount} note={note} customer_id={props?.customer_id} customer_name={props?.customer_name} customer_address={props?.customer_address} customer_phone={props?.customer_phone} customer_loan={props?.customer_loan} />
                </div> */}
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative my-6 mx-auto w-11/12 sm:w-5/6 md:w-2/3 lg:w-2/3 max-w-7xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                        قەرزی گەڕاوە
                    </h3>
                    <button
                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => props.setshow(false)}
                    >
                        <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                        X
                        </span>
                    </button>
                    </div>
                    {/*body*/}
                    <div className="relative p-6 flex-auto">
                        <div className="container mx-auto">
                            <div className="py-8">
                                <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
                                    <div className="inline-block min-w-full shadow-md rounded-lg overflow-hidden">
                                        <table className="min-w-full leading-normal">
                                        <thead>
                                            <tr>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                                    ناوی کڕیار
                                                </th>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                                    بەرواری گەڕاندنەوە
                                                </th>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                                    بڕی گەڕاوە
                                                </th>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                                    نرخی دۆلار
                                                </th>
                                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                                    تێبینی
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {props?.loan_in?.map((lis)=>(
                                            <tr key={lis.loan_in_id} className={"bg-white"}>
                                                <td className="px-5 py-5 border-b border-gray-200 text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">
                                                    {lis.customer_name}
                                                </p>
                                                </td>
                                                <td className="px-5 py-5 border-b border-gray-200  text-sm text-right">
                                                <p className="text-gray-900 whitespace-no-wrap" dir="ltr">
                                                    {moment(lis.loan_in_date).format("YYYY-MM-DD hh:mm a")}
                                                </p>
                                                </td>
                                                <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">
                                                    {numberbeautify(money_rounding(lis.loan_in_amount))} $
                                                </p>
                                                </td>
                                                <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">
                                                    {numberbeautify(money_rounding(lis.loan_in_dollar_price))}
                                                </p>
                                                </td>
                                                <td className="px-5 py-5 border-b border-gray-200  text-sm">
                                                <p className="text-gray-900 whitespace-no-wrap">
                                                    {lis?.loan_in_note}
                                                </p>
                                                </td>
                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*footer*/}
                    <div className="flex flex-col sm:flex-row items-center justify-end gap-3 p-4 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                        <button
                        className="w-full sm:w-auto bg-gray-500 text-white active:bg-gray-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-2 sm:order-1"
                        type="button"
                        onClick={() => {
                            props.setshow(false);
                        }}
                        >
                        داخستن
                        </button>
                    </div>
                    </div>
                </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
            ) : null
    )
}

export default Loan_in_detail_modal